<div id="page-loading" class="d-flex align-items-center text-center" aria-busy="true">
    <div class="icon-container">
    <img src="/images/Optimize-logo-Color.svg" height="50" width="50" alt="loading">
        <span class="inline-block pt-2 font-weight-500" translate>Loading...</span>
    </div>
</div>
